import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "qualityTracing";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    qualityTracingList: {
      list: [],
      total: 0,
    }, //列表数据
  },
  actions: {
    //获取数据
    async getQualityTracingData({ commit }, payload) {
      let result = await api.get(
        `/api/TraceCode/page?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setQualityTracingList", result.data);
      }
      return result;
    },
    //删除数据
    async delQualityTracing(a, payload) {
      let result = await api.delete(`/api/TraceCode/` + payload);
      return result;
    },
    //添加数据
    async addQualityTracing(a, payload) {
      let result = await api.post(`/api/TraceCode/`, payload);
      return result;
    },
    //获取追溯码
    async getQualityTracingCode(a, payload) {
      let result = await api.get(`/api/TraceCode/code`);
      return result.data;
    },
  },
  mutations: {
    setQualityTracingList(state, payload) {
      state.qualityTracingList = payload;
    },
  },
});

export default moduleName;
